import moment from 'moment'

export default (value, format) => {
  moment.locale(import.meta.env.VITE_COUNTRY)

  if (value) {
    const date = moment(value).format(format || 'L')
    return date !== 'Invalid date' ? date : '-'
  }

  return '-'
}
